// Вкладка «Место на диске»: диск сервера, сколько занимают отчёты, корзины и база; по пользователям - с квотой.
import { Icon } from '../../ui/icons';
import { Btn } from '../../ui/controls';
import { adminApi } from './adminApi';
import { fmtBytes, LoadError, Pill, useLoad, UsageBar } from './common';

export function StorageTab() {
  const { data, error, loading, reload } = useLoad(() => adminApi.storage(), []);
  const disk = data?.disk;
  const trash = (data?.users || []).reduce((s, u) => s + u.trashBytes, 0);
  const max = Math.max(1, ...(data?.users || []).map((u) => u.usedBytes));
  return (
    <section className="adm-tab" data-testid="admin-storage">
      <LoadError error={error} reload={reload} />
      <div className="adm-cards">
        <div className="adm-stat is-wide">
          <div className="adm-stat-label">Диск сервера</div>
          {disk ? <>
            <div className="adm-stat-value">{fmtBytes(disk.free)} <span className="adm-stat-unit">свободно из {fmtBytes(disk.total)}</span></div>
            <div className="adm-diskbar" aria-label="Занятость диска">
              <span className="is-sto" style={{ width: Math.max(0.5, (data!.totalBytes / disk.total) * 100) + '%' }} title={`Редактор: ${fmtBytes(data!.totalBytes)}`} />
              <span className="is-other" style={{ width: Math.max(0, ((disk.used - data!.totalBytes) / disk.total) * 100) + '%' }} title="Другие файлы" />
            </div>
            <div className="adm-legend"><span><i className="is-sto" /> отчёты редактора {fmtBytes(data!.totalBytes)}</span>
              <span><i className="is-other" /> другие файлы {fmtBytes(Math.max(0, disk.used - data!.totalBytes))}</span>
              <span><i /> свободно {fmtBytes(disk.free)}</span></div>
            {disk.free < 2 * 1024 ** 3 && <div className="adm-warn"><Icon name="warn" size={16} /><span>На диске мало места - сборки и сохранение могут перестать работать.</span></div>}
          </> : <div className="adm-dim">{loading ? 'Загрузка…' : 'нет сведений'}</div>}
        </div>
        <div className="adm-stat"><div className="adm-stat-label">Отчёты всех пользователей</div><div className="adm-stat-value">{data ? fmtBytes(data.totalBytes) : '…'}</div>
          <div className="adm-stat-sub">в том числе корзины {fmtBytes(trash)}</div></div>
        <div className="adm-stat"><div className="adm-stat-label">База учётных записей</div><div className="adm-stat-value">{data ? fmtBytes(data.dbBytes) : '…'}</div>
          <div className="adm-stat-sub">sto.sqlite: пользователи, сеансы, журнал</div></div>
      </div>
      <div className="adm-section-head"><span>По пользователям</span><span className="topbar-spacer" />
        <Btn icon="refresh" title="Пересчитать" onClick={() => void reload()} className={loading ? 'is-loading' : ''} /></div>
      <div className="adm-table-wrap">
        <table className="adm-table" data-testid="storage-table">
          <thead><tr><th>Пользователь</th><th>Занято</th><th>Доля</th><th className="num">Корзина</th><th className="num">Отчёты</th></tr></thead>
          <tbody>
            {(data?.users || []).map((u) => (
              <tr key={u.id} className={u.deleted ? 'is-deleted' : ''} data-testid="storage-row">
                <td><b>{u.login}</b> {u.role === 'admin' && <Pill tone="info">админ</Pill>}{u.deleted && <Pill tone="err">удалён</Pill>}</td>
                <td><UsageBar used={u.usedBytes} total={u.quotaBytes} wide /></td>
                <td><span className="adm-share"><span style={{ width: (u.usedBytes / max) * 100 + '%' }} /></span></td>
                <td className="num">{u.trashBytes ? fmtBytes(u.trashBytes) : <span className="adm-dim">—</span>}</td>
                <td className="num">{u.projects}{u.maxProjects ? <span className="adm-dim"> / {u.maxProjects}</span> : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
